import {
    get_headers,
    VIEW_REQUESTS_INFO_URL
} from '@/utils/constants/constants';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import axios from 'axios';

import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";

export default {
    name: 'ViewRequests',
    mixins: [alert_mixin, formatting_mixins],

    components: { NavigationBackButton },

    data: () => ({
        active_tab: "Unresolved",
        tabs: [
            "Unresolved",
            "Resolved",
        ],
        unresolved_requests: [],
        resolved_requests: [],
        application_id: '',
    }),
    mounted() {
        this.headers = get_headers();
        this.application_id = sessionStorage.getItem('application_id');
        this.get_application_requests();

        const saved_tab = sessionStorage.getItem("active_tab");
        if (saved_tab && this.tabs.includes(saved_tab)) {
            this.active_tab = saved_tab;
        }
    },

    methods: {
        set_active_tab(tab) {
            this.active_tab = tab;
            sessionStorage.setItem("active_tab", tab);
        },

        get_application_requests() {

            axios.get(VIEW_REQUESTS_INFO_URL, {
                headers: this.headers,
                params: {
                    application_id: parseInt(this.application_id, 10),
                }
            })
                .then(response => {
                    const response_data = response.data;

                    if (response_data.status === 'success') {

                        const mapped_request_data = response_data.data.map(request => ({
                            "id": request.id,
                            "sender": request.requested_by_first_name + " " + request.requested_by_last_name,
                            "message": request.message,
                            "is_resolved": request.is_resolved,
                            "is_sent": request.is_sent,
                            "is_read": request.is_read,
                            "date": this.format_date(request.date_created),
                        }),
                        );

                        this.unresolved_requests = mapped_request_data.filter(request => request.is_resolved === false);
                        this.resolved_requests = mapped_request_data.filter(request => request.is_resolved === true);
                    } else {
                        this.show_error('Error fetching requests');
                    }
                })
                .catch(error => {
                    if (error.response && error.response.data) {
                        this.show_error(error.response.data.message);
                    }
                });
        },

        selected_unresolved_request(unresolved_request_id) {
            this.$router.push({
                path: '/resolve_requests',
                query: {
                    request_id: unresolved_request_id,
                }
            });
        },

        view_resolved_request(resolved_id) {
            this.$router.push({
                path: '/view_resolved_requests',
                query: {
                    request_id: resolved_id,
                }
            });
        },

    }
}